import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sf-container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, " Create a Mathsframe / Spellingframe account ", -1)
const _hoisted_3 = { class: "md:tw-grid md:tw-grid-cols-2 md:tw-gap-8 lg:tw-gap-16 tw-pt-16" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " If you want to register a new user independet from you mathsframe user first logout. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountTypeOptions = _resolveComponent("AccountTypeOptions")!
  const _component_SfRouterLink = _resolveComponent("SfRouterLink")!

  return (_ctx.canRegister)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_AccountTypeOptions, { type: "individual" }),
          _createVNode(_component_AccountTypeOptions, { type: "school" })
        ])
      ]))
    : (_ctx.isMfUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", null, [
            _createTextVNode(" Otherwise "),
            _createVNode(_component_SfRouterLink, { to: "/dashboard" }, {
              default: _withCtx(() => [
                _createTextVNode("go to your dashboard")
              ]),
              _: 1
            }),
            _createTextVNode(". ")
          ])
        ]))
      : _createCommentVNode("", true)
}